import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import {
  AllCOCs,
  ApprovalPending,
  BusinessInfo,
  COCDeleteRequests,
  ForgotPassword,
  Home,
  Login,
  NewCOC,
  Profile,
  Report,
  Signup,
  Configuration,
  ExternalIntegrations,
  UserManual,
  ManualVideos,
  Technicians,
  DataCollections,
  EditCOC,
  CreateUser,
  Users,
} from "../pages";
import { ProtectedLayoutRoute, PublicLayoutRoute } from "../components";
import { AuthModel } from "../services/models";

function ExternalIntegrationsUserOnly() {
  const user = AuthModel.getUser();
  if (user?.role !== "user") {
    return <Navigate to="/" replace />;
  }
  return <ExternalIntegrations />;
}

export const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<PublicLayoutRoute />}>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
      </Route>

      {/* Protected Routes */}
      <Route element={<ProtectedLayoutRoute />}>
        <Route path="/" element={<Home />} />
        <Route path="/all-orders" element={<AllCOCs />} />
        <Route path="/new-order" element={<NewCOC />} />
        <Route path="/edit-order/:orderId" element={<EditCOC />} />
        <Route path="/approval-pending" element={<ApprovalPending />} />
        <Route path="/business-info" element={<BusinessInfo />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/report/:orderId" element={<Report />} />
        <Route path="/coc-delete-requests" element={<COCDeleteRequests />} />
        <Route path="/configuration" element={<Configuration />} />
        <Route
          path="/external-integrations"
          element={<ExternalIntegrationsUserOnly />}
        />
        <Route path="/user-manual" element={<UserManual />} />
        <Route path="/videos" element={<ManualVideos />} />
        <Route path="/technicians" element={<Technicians />} />
        <Route path="/data-collections" element={<DataCollections />} />
        <Route path="/create-user" element={<CreateUser />} />
        <Route path="/users" element={<Users />} />
      </Route>

      {/* Catch all - redirect to all-orders */}
      <Route path="*" element={<Navigate to="/all-orders" replace />} />
    </Routes>
  );
};
